import React, { useEffect, useState } from 'react'
import { v3_save_document_file, v3_ship_wise_document_list, v3_upload_document } from '../../../actions/v3/document'
import moment from 'moment'
import { getAuthHeader } from '../../../utils'
import axios from 'axios'
import { toast } from 'react-toastify'
import fileDownload from 'js-file-download';
import { v3_save_claim_file, v3_ship_wise_claim_list } from '../../../actions/v3/guaranteeClaims'


const Index = ({ shipId, refresh, setRefresh, selectedDocument, setSelectedDocument, payload }) => {
    const [claims, setClaims] = useState([])
    useEffect(() => {
        
        if (shipId) {
            setSelectedDocument('')
            v3_ship_wise_claim_list(shipId, payload).then((res) => {
                if (res.status) {
                    setClaims(res.result.claims)
                }
            })
        }
        else {
            setClaims([])
        }
    }, [shipId, refresh, payload])

    const handleDownload = async (claimId) => {
        try {
            const downloadUrl = `${process.env.REACT_APP_BASE_URL}/v3/claim/download/files/${claimId}`;
            let config = { responseType: 'blob' }
            const authHeader = getAuthHeader();
            if (authHeader?.headers) {
                config.headers = {
                    ...config.headers,
                    ...authHeader.headers,
                };
            }
            const response = await axios.get(downloadUrl, config);

            // const response = await axios.get(downloadUrl, getAuthHeader());

            const blob = new Blob([response.data], { type: 'application/zip' });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;

            link.setAttribute('download', `claim_${claimId}_files.zip`);
            document.body.appendChild(link);
            link.click();
            link.remove();

            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Download failed:', error?.response?.data || error.message);
            alert("Download failed. Please check if the document has valid files or contact support.");
        }
    };

    const handleUploadNewFile = async (e, claimId) => {
        try {

            const formData = new FormData();
            formData.append('file', e.target.files[0]);

            const upload_res = await v3_upload_document(formData);

            if (upload_res.status && upload_res.result) {
                const { fileName, originalFileName } = upload_res.result;

                const saveRes = await v3_save_claim_file({
                    fileName,
                    originalFileName,
                    claimId
                });

                if (saveRes.status) {
                    toast.success(saveRes.result.message);
                    setRefresh(!refresh)
                } else {
                    toast.error("Failed to save file metadata.");
                }
            } else {
                toast.error("Upload failed.");
            }
        } catch (err) {
            console.error("Upload error:", err);
            toast.error("Something went wrong during upload.");
        }
    };



    const handleDownloadFile = async (documentId, fileName) => {
        try {
            let config = { responseType: 'blob' }
            const authHeader = getAuthHeader();
            if (authHeader?.headers) {
                config.headers = {
                    ...config.headers,
                    ...authHeader.headers,
                };
            }
            const response = await axios.get(
                `${process.env.REACT_APP_BASE_URL}/v3/claim/download/file/${documentId}/${encodeURIComponent(fileName)}`,
                config
            );

            fileDownload(response.data, fileName);
        } catch (error) {
            console.error("Download failed:", error);
            toast.error("Failed to download file.");
        }
    };

    return (
        <div className="card card-idex-doc bsn">
            <div className="card-body card-body-document">
                <div className="table-responsive table-responsive-document">
                    <table className="table align-middle table-nowrap table-hover">
                        <thead className="table-light">
                            <tr>
                                <th scope="col">Subject</th>
                                <th scope="col">Category</th>
                                <th scope="col">Files</th>
                                <th scope="col">Modified On</th>
                                <th scope="col">Notes</th>
                                <th scope="col">Created By</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {claims.map((item) => {
                                return (
                                    <React.Fragment>

                                        <tr key={item.CLAIM_ID}
                                            onClick={() => { setSelectedDocument(item) }}
                                            className={`${selectedDocument.CLAIM_ID === item.CLAIM_ID ? 'active' : ''} `}
                                        >
                                            <td>
                                                <h5 className="font-size-14 mb-1">
                                                    <a href="javascript:void(0)" className="text-dark">
                                                        {item.SUBJECT}
                                                    </a>
                                                </h5>
                                                <span
                                                    className="badge rounded-pill bg-info"
                                                    style={{
                                                        backgroundImage:
                                                            "linear-gradient(90deg, #0ddcef, #319bfc)",
                                                        fontSize: 11
                                                    }}
                                                >
                                                    {item.STATUS}
                                                </span>
                                            </td>
                                            <td>
                                                <p className="text-muted mb-0">{item.CATEGORY_NAME || '-'}</p>
                                            </td>
                                            <td>
                                                <div className="dropdown ">
                                                    <span
                                                        className="text-muted mb-0 dropdown-toggle"
                                                        role="button"
                                                        id={`dropdownMenuButton-${item.CLAIM_ID}`}
                                                        data-bs-toggle="dropdown"
                                                        aria-expanded="false"
                                                    >
                                                        {item.FILE_COUNT} Files{" "}
                                                        <span style={{ color: "#08c" }}>
                                                            <i
                                                                className="fa fa-download"
                                                                style={{ color: "#f46a6a" }}
                                                                aria-hidden="true"
                                                            />
                                                        </span>
                                                    </span>

                                                    <ul className="dropdown-menu dropdown-menu-decument" aria-labelledby={`dropdownMenuButton-${item.CLAIM_ID}`}>
                                                        {item.documents.map((file, index) => {
                                                            const displayName = file.ORIGINAL_FILE_NAME || file.originalFileName || file.FILE_NAME || file.fileName;
                                                            return (
                                                                <li>
                                                                    <a
                                                                        className="dropdown-item"
                                                                        href="javascript:void(0);"
                                                                        onClick={() => handleDownloadFile(item.CLAIM_ID, file.FILE_NAME)}
                                                                    >
                                                                        {index + 1}{`)`} {displayName}
                                                                    </a>
                                                                </li>
                                                            )
                                                        })}
                                                    </ul>
                                                </div>
                                            </td>

                                            <td>
                                                <p className="text-muted mb-0">
                                                    <span style={{ color: "#08c !important" }}>
                                                        {item.MODIFIED_ON
                                                            ? moment(item.MODIFIED_ON).format('DD MMM, YYYY')
                                                            : "N/A"}
                                                    </span>
                                                </p>
                                            </td>

                                            <td>
                                                <p className="text-muted mb-0">
                                                    <a href="javascript:void(0)">
                                                        <i className="fa fa-comments" aria-hidden="true" /> ({item.comments.length})
                                                    </a>
                                                </p>
                                            </td>
                                            <td>
                                                <p className="text-muted mb-0">{item.CREATED_BY_NAME}</p>
                                            </td>
                                            <td>
                                                <ul className="list-inline font-size-20 contact-links mb-0">
                                                    <li className="list-inline-item px-0">
                                                        <a
                                                            href="javascript:void(0)"
                                                            title="Upload More"
                                                            onClick={() =>
                                                                document.getElementById(`upload-document-${item.CLAIM_ID}`).click()
                                                            }
                                                        >
                                                            <input
                                                                type="file" // ✅ REQUIRED for file upload
                                                                id={`upload-document-${item.CLAIM_ID}`}
                                                                style={{ display: 'none' }}
                                                                onChange={(e) => handleUploadNewFile(e, item.CLAIM_ID)}
                                                            />
                                                            <i className="bx bx-upload" />
                                                        </a>
                                                    </li>

                                                    <li className="list-inline-item px-0">
                                                        <div className="dropdown hover-dropdown">
                                                            <a
                                                                href="javascript:void(0)"
                                                                title="Download"
                                                                onClick={() => handleDownload(item.CLAIM_ID)}
                                                            >
                                                                <i className="bx bx-download" />
                                                            </a>
                                                            <ul className="dropdown-menu dropdown-menu-decument">
                                                                <li>
                                                                    <button
                                                                        type="button"
                                                                        className="dropdown-item"
                                                                        onClick={() => handleDownload(item.CLAIM_ID)}
                                                                    >
                                                                        Download all (.zip)
                                                                    </button>
                                                                </li>
                                                                {item.documents?.length ? (
                                                                    item.documents.map((file, index) => (
                                                                        <li key={`${file.FILE_NAME || index}`}>
                                                                            <button
                                                                                type="button"
                                                                                className="dropdown-item"
                                                                                onClick={() => handleDownloadFile(item.CLAIM_ID, file.FILE_NAME)}
                                                                            >
                                                                                {file.ORIGINAL_FILE_NAME || file.FILE_NAME}
                                                                            </button>
                                                                        </li>
                                                                    ))
                                                                ) : (
                                                                    <li>
                                                                        <span className="dropdown-item text-muted">No files</span>
                                                                    </li>
                                                                )}
                                                            </ul>
                                                        </div>
                                                    </li>


                                                </ul>
                                            </td>
                                        </tr>

                                    </React.Fragment>

                                )
                            })}
                            {claims.length === 0 && (
                                <tr>
                                    <td colSpan="7" className="text-center text-muted">
                                        No documents found for this ship.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

            </div>
        </div>


    )
}

export default Index
